import { ClientItemId } from 'owa-client-ids';
import { ActionSource } from 'owa-mail-store';
import { action } from 'satcheljs';

export default action(
    'SHOW_IN_IMMERSIVE_READER',
    (itemId: ClientItemId, actionSource: ActionSource) => {
        return {
            itemId,
            actionSource,
        };
    }
);
